module.exports = __webpack_public_path__ + "staticcomp/img/content_6.b4a887a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/content_6.jpg
// module id = TOne
// module chunks = 39